<template>
  <div v-if="isShowNav" class="anchor-nav">
    <ul class="anchor-list" :style="anchorBox">
      <li
        :key="item.anchor"
        v-for="item in anchorList"
        :class="activityName === item.name ? 'item activity' : 'item'"
        @click="toAnchor(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
const PATHNAME = 'ChartsDetail';
const PATHNAME_RESOURCE = 'ChartsResourceDetail';
export default {
  data() {
    return {
      isShowNav: false,
      isResource: false,
      activityName: '',
      isBindScroll: false,
      anchorBox: {},
      anchorList: [
        { anchor: 'map_detail_product_data', name: '作品数据' },
        { anchor: 'map_detail_core_data', name: '核心数据总览' },
        { anchor: 'map_detail_exposure_from_data', name: '来源及曝光数据' },
        { anchor: 'map_detail_product_detail_data', name: '作品详细数据' },
        { anchor: 'map_detail_buy_income_data', name: '内购收益数据' },
        { anchor: 'map_kv_data_err', name: 'KV数据查询' },
        { anchor: 'map_log_data', name: '日志查询' },
        { anchor: 'map_kv_rollback_log', name: 'KV数据回档' },
      ],
    };
  },
  methods: {
    setAnchorList() {
      if (this.isResource) {
        this.anchorList = [
          { anchor: 'map_detail_product_data', name: '作品数据' },
          { anchor: 'map_detail_product_detail_data', name: '作品详细数据' },
        ];
      } else {
        this.anchorList = [
          { anchor: 'map_detail_product_data', name: '作品数据' },
          { anchor: 'map_detail_core_data', name: '核心数据总览' },
          { anchor: 'map_detail_exposure_from_data', name: '来源及曝光数据' },
          { anchor: 'map_detail_product_detail_data', name: '作品详细数据' },
          { anchor: 'map_detail_buy_income_data', name: '内购收益数据' },
          { anchor: 'map_kv_data_err', name: 'KV数据查询' },
          { anchor: 'map_log_data', name: '日志查询' },
          { anchor: 'map_kv_rollback_log', name: 'KV数据回档' },
        ];
      }
    },
    toAnchor(item) {
      let el = document.getElementById(`${item.anchor}`);
      let page = document.querySelector('html');
      let height = el.offsetTop; // 计算需要向上移动的距离
      // console.log('height', height, el, page);
      page.scroll({
        top: height,
        behavior: 'smooth', // 平滑移动
      });
      this.activityName = item.name;
    },
    handlerScroll() {
      window.addEventListener('scroll', () => {
        this.isBindScroll = true;
        if (!this.isBindScroll || !this.isShowNav) return;
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollHeight > 720) {
          this.anchorBox = { position: 'fixed' };
        } else {
          this.anchorBox = { position: 'initial' };
        }
      });
    },
    scroll() {
      this.isShowNav = false;
      this.isBindScroll = false;
    },
  },
  created() {
    if (
      this.$route.name === PATHNAME ||
      this.$route.name === PATHNAME_RESOURCE
    ) {
      this.isShowNav = true;
      this.handlerScroll();
      if (this.$route.name === PATHNAME_RESOURCE) {
        this.isResource = true;
      } else {
        this.isResource = false;
      }
      this.setAnchorList();
    }
  },
  watch: {
    $route(toPath, fromPath) {
      if (toPath.name === PATHNAME || toPath.name === PATHNAME_RESOURCE) {
        this.isShowNav = true;
        this.handlerScroll();
        if (toPath.name === PATHNAME_RESOURCE) {
          this.isResource = true;
        } else {
          this.isResource = false;
        }
        this.setAnchorList();
      } else if (this.isShowNav) {
        this.scroll();
        window.removeEventListener('scroll', () => {}, false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.anchor-nav {
  position: absolute;
  // bottom: -100%;
  .anchor-list {
    top: 80px;
    border-radius: 5px;
    color: #303133;
    width: 200px;
    line-height: 35px;
    background: #ffffff;
    text-indent: 1.5em;
    cursor: pointer;
    & > .item {
      border-bottom: 1px solid #f5f5f5;
    }
    & > .activity {
      color: #222222;
      font-weight: bold;
    }
  }
}
.sidebar-wrapper {
  width: 200px;
  overflow: hidden;
}
</style>
